import { SessionCXCtrl } from '~/components/ClientExperience/OneFlow/controllers/session-cx.controller';
import { CXUserStore } from '~/components/ClientExperience/OneFlow/stores/cx-user.store';
import {
    AuthenticatedGlobalContext,
    AuthenticatedGlobalContextValue
} from '~/providers/base-global-context/authenticated-global.context';
import { IApiService } from '~/services/interfaces/IApiService';
import { CXApiService } from '~/components/ClientExperience/services/cx-api.service';
import { CXSessionService } from '~/components/ClientExperience/OneFlow/services/cx-session.service';
import { ClientPortalConfigStore } from '~/components/ClientExperience/stores/client-portal-config.store';
import { CX_APP_ROUTER_BASE_PATH } from '~/constants/client-experience.consts';
import { CXSessionStore } from '~/components/ClientExperience/OneFlow/stores/cx-session-store';
import { TGlobalContextType } from '~/types/global-context.types';
import { BaseSessionStore } from '~/stores/base-session.store';

export interface GlobalCXContextValue extends AuthenticatedGlobalContextValue {
    get clientPortalConfigStore(): ClientPortalConfigStore;

    get sessionCtrl(): SessionCXCtrl;

    get sessionStore(): CXSessionStore;

    get userStore(): CXUserStore;

    get sessionService(): CXSessionService;
}

export class GlobalCXContext
    extends AuthenticatedGlobalContext
    implements GlobalCXContextValue
{
    // Config
    clientPortalConfigStore: ClientPortalConfigStore;

    sessionCtrl: SessionCXCtrl;
    get userStore() {
        return this._userStore as CXUserStore;
    }
    get sessionStore() {
        return this._sessionStore as CXSessionStore;
    }
    sessionService: CXSessionService;

    constructor() {
        super();
        this.clientPortalConfigStore = new ClientPortalConfigStore(this);

        this.sessionCtrl = new SessionCXCtrl(this, CX_APP_ROUTER_BASE_PATH);
        this.sessionService = new CXSessionService(this.apiService);
    }

    initApiServices(): IApiService {
        return new CXApiService(this);
    }

    initUserStore() {
        return new CXUserStore(this);
    }

    initSessionStore(): BaseSessionStore {
        return new CXSessionStore();
    }

    get globalContextType(): TGlobalContextType {
        return 'CX';
    }
}
